package er.prateek.crossly.ads

/**
 * AdSense.
 *
 * [supportsFullScreenAds] is `false` and that is not a stub: AdSense exposes no programmatic
 * interstitial or rewarded API for an ordinary site. Its closest equivalents -- vignette and
 * rewarded formats -- are served by Auto ads from the publisher console, entirely outside
 * app code. So the web build runs banners only, and [AdsCoordinator] never consults the
 * pacing logic here.
 */
private object WebAdHost : AdHost {

    override val supportsFullScreenAds: Boolean = false

    override suspend fun initialize(config: AdsConfig) {
        // Loading the AdSense script is the whole of "initialization"; the banner slots
        // themselves are created lazily by PlatformAdBanner as screens mount.
        ensureAdSenseScript(AdUnitIds.webClient(config))
    }

    override fun preloadInterstitial(config: AdsConfig) = Unit
    override suspend fun showInterstitial(config: AdsConfig): Boolean = false
    override fun preloadRewarded(config: AdsConfig) = Unit
    override suspend fun showRewarded(config: AdsConfig): Boolean = false
}

actual object AdHostProvider {
    actual val adHost: AdHost = WebAdHost
}
